/// <amd-module name="Reporting/Visuals/LayoutComponents/Widgets/SubmetricsComponent" />
import * as React from "react";

import { DemandType } from "Widgets/Demands/DemandType";
import { IDemandHandler } from "Widgets/Demands/IDemandHandler";

/**
 * Stateless parameters (creation-time) for constructing a ScalarComponent (e.g. a "Hero Metric")
 */
export class SubmetricsComponentProps {
    public items: SubmetricsItem[];
}

export class SubmetricsItem {
    public label: string;
    public value: string;
    public onClick?: () => void;
}

export const SubmetricsComponent: React.StatelessComponent<SubmetricsComponentProps> = (props: SubmetricsComponentProps) => {
    const items: any = []; // Need "any" because there's no way to cast space to JSX.Element. Space is needed for text-align:justify styling between items.
    if (props.items) {
        props.items.forEach(item => {
            items.push(
                <div className="submetrics-item" key={item.label}>
                    <div className="submetrics-label">
                        {!!item.onClick ? (
                            <a className="bolt-link" onClick={item.onClick}>
                                {item.label}
                            </a>
                        ) : (
                            item.label
                        )}
                    </div>
                    <div className="submetrics-value">{item.value}</div>
                </div>
            );

            items.push(" ");
        });
    }

    return <div className="submetrics-component">{items}</div>;
};

export default class SubmetricsComponentRenderer {
    public static registerDemands(demandHandler: IDemandHandler): void {
        demandHandler.registerDemand(DemandType.submetrics);
    }

    public static renderSubmetricsComponent(props?: SubmetricsComponentProps): JSX.Element | null {
        if (!props) {
            return null;
        }
        return <SubmetricsComponent {...props} />;
    }
}
